<template>
    <div class="left_panel paymant_method_panel">
        <h2 class="font_size_20 font-weight-bold mb-0">Manage Payment</h2>
        <div class="subhead font_size_16 text_light_grey mb-0">
            View and manage the payment methods in your account.
        </div>

        <div
            class="payment_option"
            v-if="
                term_payment_info.creditlimit &&
                term_payment_info.creditlimit > 0
            "
        >
            <h2 class="font_size_16 font-weight-bold mb-2">
                Term Payment Info
            </h2>
            <div class="payment_option_blocks">
                <div class="option_block option_display">
                    <span class="option_name">Credit limit: </span>
                    <span class="option_value">{{
                        icPriceFormat(term_payment_info.creditlimit || 0)
                    }}</span>
                </div>
                <div class="option_block">
                    <span class="option_name">Unpaid Invoices:</span>
                    <span class="option_value text-danger">{{
                        icPriceFormat(term_payment_info.unpaid_invoices || 0)
                    }}</span>
                </div>
                <div class="option_block">
                    <span class="option_name">Overdue balance:</span>
                    <span
                        class="option_value"
                        :class="{
                            'text-danger': term_payment_info.overdue_balance < 0
                        }"
                        >{{
                            icPriceFormat(
                                term_payment_info.overdue_balance || 0
                            )
                        }}</span
                    >
                </div>
                <div class="option_block">
                    <span class="option_name">Unbilled orders:</span>
                    <span class="option_value text-danger">{{
                        icPriceFormat(term_payment_info.unbilled_orders || 0)
                    }}</span>
                </div>
                <div class="option_block">
                    <span class="option_name">Unapplied credits:</span>
                    <span
                        class="option_value"
                        :class="{
                            'text-danger':
                                term_payment_info.unapplied_credits < 0
                        }"
                        >{{
                            icPriceFormat(
                                term_payment_info.unapplied_credits || 0
                            )
                        }}</span
                    >
                </div>
                <div class="option_block option_bottom_display">
                    <span class="option_name">Available on Account:</span>
                    <span
                        class="option_value"
                        :class="{
                            'text-danger':
                                term_payment_info.avalaible_on_account < 0
                        }"
                        >{{
                            icPriceFormat(
                                term_payment_info.avalaible_on_account || 0
                            )
                        }}</span
                    >
                </div>
            </div>
        </div>

        <div class="payment_cards">
            <h2 class="font_size_16 font-weight-bold mb-2">Payment Methods</h2>
            <div class="d-flex flex-wrap">
                <div
                    class="payment-card"
                    v-for="(payment_methods, indx) in all_payment_methods"
                    :key="indx"
                >
                    <div class="payment_box">
                        <div
                            v-if="
                                payment_methods.payment.creditCard.cardType ==
                                'Visa'
                            "
                        >
                            <img
                                :src="
                                    base_url +
                                    '/maincss/images/add_visa_logo.png'
                                "
                                alt=" "
                            />
                        </div>
                        <div
                            v-else-if="
                                payment_methods.payment.creditCard.cardType ==
                                'MasterCard'
                            "
                        >
                            <img
                                :src="
                                    base_url +
                                    '/maincss/images/master_card_logo.png'
                                "
                                alt=" "
                            />
                        </div>
                        <div
                            v-else-if="
                                payment_methods.payment.creditCard.cardType ==
                                'JCB'
                            "
                        >
                            <img
                                :src="base_url + '/maincss/images/jcb_logo.svg'"
                                alt=" "
                            />
                        </div>
                        <div
                            v-else-if="
                                payment_methods.payment.creditCard.cardType ==
                                'Discover'
                            "
                        >
                            <img
                                :src="
                                    base_url +
                                    '/maincss/images/discover_logo.svg'
                                "
                                alt=" "
                            />
                        </div>
                        <div
                            v-else-if="
                                payment_methods.payment.creditCard.cardType ==
                                'AmericanExpress'
                            "
                        >
                            <img
                                :src="
                                    base_url +
                                    '/maincss/images/american_express_logo.svg'
                                "
                                alt=" "
                            />
                        </div>
                        <div v-else>
                            <img
                                :src="
                                    base_url +
                                    '/maincss/images/unknown_card_logo.svg'
                                "
                                alt=" "
                            />
                        </div>

                        <h4 class="font_size_20 font-weight-bold mb-0 mt_22">
                            {{ payment_methods.billTo.firstName | capitalize }}
                        </h4>
                        <h3 class="font_size_26 text_light_grey mb-0 mt_10">
                            **** **** ****
                            <span class="option_value">{{
                                payment_methods.payment.creditCard.cardNumber.substr(
                                    -4
                                )
                            }}</span>
                        </h3>
                        <p class="font_size_14 text_light_grey mb-0 mt_4">
                            Expires on
                            {{
                                payment_methods.payment.creditCard.expirationDate.split(
                                    "-"
                                )[1] +
                                " / " +
                                payment_methods.payment.creditCard.expirationDate
                                    .split("-")[0]
                                    .split(/(.{2})/)
                                    .filter((x) => x.length == 2)[1]
                            }}
                        </p>
                        <div class="payment_icons">
                            <a
                                class="mr_14"
                                href="javascript::void(0)"
                                @click="
                                    getSinglePaymentMethod(
                                        payment_methods.customerPaymentProfileId
                                    )
                                "
                                v-tooltip="'Edit'"
                                ><img
                                    src="/maincss/images/edit_payment.svg"
                                    alt=" "
                            /></a>
                            <a
                                href="#"
                                v-tooltip="'Delete'"
                                data-toggle="modal"
                                :data-target="
                                    '#delete-resource-payment' +
                                    payment_methods.customerPaymentProfileId
                                "
                                class="delete-link"
                                ><img
                                    src="/maincss/images/payment_delete.svg"
                                    alt=" "
                            /></a>
                        </div>
                    </div>

                    <!-- Delete Model -->

                    <div
                        class="modal fade text-left delete_popup"
                        :id="
                            'delete-resource-payment' +
                            payment_methods.customerPaymentProfileId
                        "
                        tabindex="-1"
                        role="dialog"
                        aria-labelledby="basicModalLabel3"
                        aria-hidden="true"
                    >
                        <div
                            class="modal-dialog modal-dialog-centered"
                            role="document"
                        >
                            <div class="modal-content">
                                <div class="modal-header border-0 bg-lightblue">
                                    <h4
                                        class="modal-title"
                                        id="basicModalLabel3"
                                    >
                                        Are you sure you want to delete?
                                    </h4>
                                    <button
                                        type="button"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                        class="close"
                                    >
                                        <img
                                            src="/maincss/images/cancel.svg"
                                            alt=" "
                                        />
                                    </button>
                                </div>
                                <div class="modal-body text-center pb-0">
                                    <p>
                                        Do you really want to delete these
                                        record?
                                    </p>
                                </div>
                                <div
                                    class="modal-footer text-center justify-content-center align-items-center pb_36 border-0"
                                >
                                    <button
                                        type="button"
                                        @click="
                                            removeResoursce(
                                                payment_methods.customerPaymentProfileId
                                            )
                                        "
                                        class="btn btn-outline-primary mr_10"
                                    >
                                        Yes
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn_primary bg_primary_blue text_white"
                                        data-dismiss="modal"
                                    >
                                        No
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mr_26 payment-card">
                    <a
                        href="javascript:void(0);"
                        class="payment_box d-flex justify-content-center align-items-center flex-column text-center h-100"
                        data-keyboard="false"
                        data-toggle="modal"
                        data-target="#add_payment_method_model"
                        data-dismiss="modal"
                    >
                        <img src="/maincss/images/add_more_brand.svg" alt=" " />
                        <p
                            class="font_size_20 text_primary_blue mt_18 mb-0"
                            style="color: #0079c1 !important"
                        >
                            Add a Payment Method
                        </p>
                    </a>
                </div>
            </div>
        </div>
        <!-- Add Payment Method Model -->
        <div
            class="modal login-form-popup fade h-auto payment_popup"
            id="add_payment_method_model"
            tabindex="-1"
            aria-labelledby="address"
            aria-hidden="true"
            data-keyboard="false"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            >
                <div class="modal-content">
                    <div class="modal-body">
                        <a
                            href="#"
                            class="popup-close"
                            id="popup-close-paymentform"
                            data-dismiss="modal"
                        >
                            <img src="/maincss/images/cancel.svg" alt=" " />
                        </a>
                        <div class="address-form">
                            <h3 v-if="!card_info.id">Add New Payment Method</h3>
                            <h3 v-else>Update Payment Method</h3>
                            <form
                                method="post"
                                @submit.prevent="addNewPaymentMethod"
                                data-vv-scope="paymentform"
                                :key="'paymentform'"
                            >
                                <div class="form-group">
                                    <input
                                        type="hidden"
                                        v-model="card_info.id"
                                    />
                                    <div v-if="card_info.id">
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="cardnumber"
                                            name="cardnumber"
                                            disabled
                                            :value="
                                                '#### #### #### ' +
                                                card_info.cardnumber.substr(-4)
                                            "
                                        />
                                    </div>
                                    <div v-else>
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="cardnumber"
                                            name="cardnumber"
                                            placeholder="Enter Card Number"
                                            v-model="card_info.cardnumber"
                                            v-validate="
                                                'required|min:17|max:19'
                                            "
                                            data-vv-as="Card Number"
                                            v-mask="
                                                masklength == null
                                                    ? '#### #### #### #'
                                                    : masklength == 14
                                                    ? '#### #### #### ##'
                                                    : masklength == 15
                                                    ? '#### ###### #####'
                                                    : masklength == 16
                                                    ? '#### #### #### ####'
                                                    : masklength == 17
                                                    ? '#### #### #### ####'
                                                    : '#### #### #### ####'
                                            "
                                            @input="cardNumberFormate"
                                        />
                                    </div>
                                    <label style="margin-top: -20px"
                                        >Card Number</label
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <small
                                        class="form-text text-error text-left"
                                        v-show="
                                            errors.has('paymentform.cardnumber')
                                        "
                                    >
                                        {{
                                            errors.first(
                                                "paymentform.cardnumber"
                                            )
                                        }}
                                    </small>
                                </div>
                                <div class="form-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="cardholdername"
                                        name="cardholdername"
                                        v-model="card_info.cardholdername"
                                        v-validate="'required|max:50'"
                                        data-vv-as="Card Holder"
                                        placeholder="Enter Card Holder Name"
                                    />
                                    <label class="card-holder"
                                        >Card Holder Name</label
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <small
                                        class="form-text text-error text-left"
                                        v-show="
                                            errors.has(
                                                'paymentform.cardholdername'
                                            )
                                        "
                                    >
                                        {{
                                            errors.first(
                                                "paymentform.cardholdername"
                                            )
                                        }}
                                    </small>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label
                                                style="margin-top: -20px"
                                                class="select_option_label"
                                                >Month</label
                                            >
                                            <select
                                                class="form-control bg-transparent"
                                                v-model="
                                                    card_info.cardexpiremonth
                                                "
                                                name="Expiration Month"
                                                v-validate="'required'"
                                                data-vv-as="Expiration Month"
                                            >
                                                <option
                                                    v-for="n in 12"
                                                    :value="
                                                        10 > n ? '0' + n : n
                                                    "
                                                    :key="n"
                                                    :disabled="
                                                        (n <
                                                            (
                                                                '0' +
                                                                (new Date().getMonth() +
                                                                    1)
                                                            ).slice(-2) &&
                                                            changedYear <=
                                                                currentYear) ||
                                                        card_info.cardexpireyear <
                                                            currentYear
                                                    "
                                                >
                                                    {{ 10 > n ? "0" + n : n }}
                                                </option>
                                            </select>
                                            <small
                                                class="form-text text-error text-left"
                                                v-show="
                                                    errors.has(
                                                        'paymentform.Expiration Month'
                                                    )
                                                "
                                            >
                                                {{
                                                    errors.first(
                                                        "paymentform.Expiration Month"
                                                    )
                                                }}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label
                                                style="margin-top: -20px"
                                                class="select_option_label"
                                                >Year</label
                                            >
                                            <select
                                                class="form-control bg-transparent"
                                                v-model="
                                                    card_info.cardexpireyear
                                                "
                                                name="Expiration Year"
                                                v-validate="'required'"
                                                data-vv-as="Expiration Year"
                                                @change="changeCardYear($event)"
                                            >
                                                <option
                                                    v-for="year in years"
                                                    :key="year"
                                                    :value="
                                                        year
                                                            .toString()
                                                            .substr(-2)
                                                    "
                                                    :disabled="
                                                        year
                                                            .toString()
                                                            .substr(-2) <
                                                        currentYear
                                                    "
                                                >
                                                    {{ year }}
                                                </option>
                                            </select>
                                            <small
                                                class="form-text text-error text-left"
                                                v-show="
                                                    errors.has(
                                                        'paymentform.Expiration Year'
                                                    )
                                                "
                                            >
                                                {{
                                                    errors.first(
                                                        "paymentform.Expiration Year"
                                                    )
                                                }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <button
                                    v-if="!card_info.id"
                                    type="submit"
                                    class="btn btn_orange bg_primary_orange text_white w-100 mt_34 mb_32 btn_h60"
                                >
                                    Add
                                </button>
                                <button
                                    v-else
                                    type="submit"
                                    class="btn btn_orange bg_primary_orange text_white w-100 mt_34 mb_32 btn_h60"
                                >
                                    Update
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="preloader" v-show="isBusy">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";
import ApiService from "@/common/api.service";

export default {
    name: "ManagePayment",
    directives: { mask },
    components: {},
    computed: {
        ...mapGetters(["isAuthenticated", "currentUserClient"]),
        years() {
            if (this.card_info.id) {
                if (this.card_info.cardexpireyear < this.currentYear) {
                    const year = 2021;
                    return Array.from(
                        { length: 15 },
                        (value, index) => year + index
                    );
                } else {
                    const year = new Date().getFullYear();
                    return Array.from(
                        { length: 15 },
                        (value, index) => year + index
                    );
                }
            } else {
                const year = new Date().getFullYear();
                return Array.from(
                    { length: 15 },
                    (value, index) => year + index
                );
            }
        }
    },
    data() {
        return {
            base_url: window.location.origin,
            isBusy: false,
            masklength: "",
            currentYear: new Date().getFullYear().toString().substr(-2), //For Card Expiry Year
            changedYear: "",
            card_info: {
                id: "",
                cardtype: "",
                cardimage: "",
                cardnumber: "",
                cardholdername: "",
                cardexpiremonth: ("0" + (new Date().getMonth() + 1)).slice(-2), //new Date().getMonth() + 1,
                cardexpireyear: new Date().getFullYear().toString().substr(-2)
            },
            all_payment_methods: [],
            term_payment_info: {
                avalaible_on_account: 0,
                creditlimit: 0,
                overdue_balance: 0,
                unbilled_orders: 0,
                unpaid_invoices: 0
            },
            load_page: false,
            unsynced_orders_amount: 0,
            total_orders: 0
        };
    },
    mounted() {
        var _this = this;
        document.body.classList.add("bg_primary_light_white");
        /* eslint-disable */
        $(function () {
            $("#item2").click(function () {
                $("#submenu2").slideToggle(500);
            });
        });
        $(document).on(
            "hide.bs.modal",
            "#add_payment_method_model",
            function () {
                _this.$validator.reset();
                (_this.currentYear = new Date()
                    .getFullYear()
                    .toString()
                    .substr(-2)), //For Card Expiry Year
                    (_this.changedYear = ""),
                    (_this.card_info = {
                        id: "",
                        cardtype: "",
                        cardimage: "",
                        cardnumber: "",
                        cardholdername: "",
                        cardexpiremonth: (
                            "0" +
                            (new Date().getMonth() + 1)
                        ).slice(-2), //new Date().getMonth() + 1,
                        cardexpireyear: new Date()
                            .getFullYear()
                            .toString()
                            .substr(-2)
                    });
            }
        );
        /* eslint-enable */
        _this.getAllPaymentMethods();
        // _this.getOrdersCount();
        const dict = {
            custom: {
                cardnumber: {
                    min: "Card Number should atleast 14 digits.",
                    max: "Card Number can not exceed 16 digits."
                }
            }
        };
        _this.$validator.localize("en", dict);
    },
    methods: {
        cardNumberFormate() {
            if (this.card_info.cardnumber.replace(/\s/g, "").length < 14) {
                this.masklength = "";
            }
            if (this.card_info.cardnumber.replace(/\s/g, "").length == 14) {
                this.masklength = 14;
            }
            if (this.card_info.cardnumber.replace(/\s/g, "").length == 15) {
                this.masklength = 15;
            }
            if (this.card_info.cardnumber.replace(/\s/g, "").length == 16) {
                this.masklength = 16;
            }
            if (this.card_info.cardnumber.replace(/\s/g, "").length > 16) {
                this.masklength = 17;
            }
        },
        changeCardYear(event) {
            var _this = this;
            _this.changedYear = event.target.value;
            if (_this.changedYear == _this.currentYear) {
                _this.card_info.cardexpiremonth = (
                    "0" +
                    (new Date().getMonth() + 1)
                ).slice(-2); //new Date().getMonth() + 1;
            } else {
                _this.card_info.cardexpiremonth = "01";
            }
        },
        addNewPaymentMethod() {
            var _this = this;
            _this.$validator.validateAll("paymentform").then((isValid) => {
                if (isValid) {
                    var _this = this;
                    _this.isBusy = true;

                    if (_this.card_info.id) {
                        new Promise(() => {
                            ApiService.put(
                                "/updatePaymentMethod",
                                _this.card_info
                            )
                                .then(({ data }) => {
                                    if (data.error) {
                                        document
                                            .getElementById(
                                                "popup-close-paymentform"
                                            )
                                            .click();
                                        _this.$toast.error(data.error, {
                                            position: "top-right"
                                        });
                                    }
                                    if (
                                        data.message ==
                                        "Payment method updated successfully."
                                    ) {
                                        document
                                            .getElementById(
                                                "popup-close-paymentform"
                                            )
                                            .click();
                                        _this.$toast.success(
                                            "Payment method updated successfully.",
                                            {
                                                position: "top-right"
                                            }
                                        );
                                    } else {
                                        document
                                            .getElementById(
                                                "popup-close-paymentform"
                                            )
                                            .click();
                                        _this.$toast.error(data.message, {
                                            position: "top-right"
                                        });
                                    }
                                    _this.getAllPaymentMethods();
                                    _this.isBusy = false;
                                })
                                .catch(({ response }) => {
                                    console.log(response.status);
                                    if (response.status == 401) {
                                        _this.$router.push({
                                            name: "/admin/login"
                                        });
                                    }
                                });
                        });
                    } else {
                        new Promise(() => {
                            ApiService.post(
                                "/addPaymentMethod",
                                _this.card_info
                            )
                                .then(({ data }) => {
                                    if (
                                        data.message ==
                                        "Payment method added successfully."
                                    ) {
                                        document
                                            .getElementById(
                                                "popup-close-paymentform"
                                            )
                                            .click();
                                        _this.$toast.success(data.message, {
                                            position: "top-right"
                                        });
                                    } else {
                                        document
                                            .getElementById(
                                                "popup-close-paymentform"
                                            )
                                            .click();
                                        _this.$toast.error(data.message, {
                                            position: "top-right"
                                        });
                                    }

                                    if (data.error) {
                                        document
                                            .getElementById(
                                                "popup-close-paymentform"
                                            )
                                            .click();
                                        _this.$toast.error(data.error, {
                                            position: "top-right"
                                        });
                                    }
                                    _this.getAllPaymentMethods();
                                    _this.isBusy = false;
                                })
                                .catch(({ response }) => {
                                    console.log(response.status);
                                    _this.isBusy = false;
                                    if (response.status == 401) {
                                        _this.$router.push({
                                            name: "/admin/login"
                                        });
                                    }
                                });
                        });
                    }
                } else {
                    _this.isBusy = false;
                    console.log("gjhghj", _this.errors);
                }
            });
        },
        getAllPaymentMethods() {
            var _this = this;
            _this.isBusy = true;
            new Promise(() => {
                ApiService.get("/getAllPaymentMethods")
                    .then(async ({ data }) => {
                        _this.all_payment_methods = data.all_payment_methods;
                        if (!this.load_page) {
                            await _this.getCustomerTermDetails();
                            this.load_page = true;
                        }
                        _this.isBusy = false;
                    })
                    .catch(({ response }) => {
                        console.log(response.status);
                        _this.isBusy = false;
                        if (response.status == 401) {
                            _this.$router.push({ name: "/admin/login" });
                        }
                    });
            });
        },
        getSinglePaymentMethod(id) {
            var _this = this;
            _this.isBusy = true;
            new Promise(() => {
                ApiService.get("/getSinglePaymentMethod/" + id)
                    .then(({ data }) => {
                        /* eslint-disable */
                        $("#add_payment_method_model").modal("show");
                        /* eslint-enable */
                        _this.card_info.id =
                            data.payment_method.customerPaymentProfileId;
                        _this.card_info.cardtype =
                            data.payment_method.payment.creditCard.cardType;
                        _this.card_info.cardimage = "";
                        _this.card_info.cardnumber =
                            data.payment_method.payment.creditCard.cardNumber.replace(
                                /\s/g,
                                ""
                            );
                        _this.card_info.cardholdername =
                            data.payment_method.billTo.firstName;
                        _this.card_info.cardexpiremonth =
                            data.payment_method.payment.creditCard.expirationDate
                                .split("-")[1]
                                .trim();
                        _this.card_info.cardexpireyear =
                            data.payment_method.payment.creditCard.expirationDate
                                .split("-")[0]
                                .split(/(.{2})/)
                                .filter((x) => x.length == 2)[1]
                                .trim();
                        _this.isBusy = false;
                    })
                    .catch(({ response }) => {
                        /* eslint-disable */
                        context.commit(SET_ERROR, response.data.errors);
                        /* eslint-enable */
                    });
            });
        },
        removeResoursce(id) {
            var _this = this;
            _this.isBusy = true;
            new Promise(() => {
                ApiService.delete("/deletePaymentMethod/" + id)
                    .then(({ data }) => {
                        if (data.success) {
                            this.$emit("updatelist");
                            /* eslint-disable */
                            $("#delete-resource-payment" + id).modal("hide");
                            /* eslint-enable */
                            _this.$toast.error("Record deleted successfully.", {
                                position: "top-right"
                            });
                        }
                        _this.isBusy = false;
                        _this.getAllPaymentMethods();
                    })
                    .catch(({ response }) => {
                        /* eslint-disable */
                        context.commit(SET_ERROR, response.data.errors);
                        /* eslint-enable */
                    });
            });
        },
        getCustomerTermDetails() {
            if (!this.currentUserClient.netsuite_id) {
                return;
            }

            return new Promise((resolve, reject) => {
                ApiService.query("/get-customer-term-details", {
                    params: { external_id: this.currentUserClient.netsuite_id }
                })
                    .then(async ({ data }) => {
                        if (!data.success) {
                            reject(data);
                        }

                        let termDetails = data.termDetails;
                        if (termDetails.length > 0) {
                            await this.getUnsyncedOrdersAmount();

                            this.term_payment_info = termDetails[0];
                            this.term_payment_info.unbilled_orders =
                                parseFloat(
                                    this.term_payment_info.unbilled_orders
                                ) + parseFloat(this.unsynced_orders_amount);
                            this.term_payment_info.avalaible_on_account =
                                parseFloat(
                                    this.term_payment_info
                                        .avalaible_on_account || 0
                                ) - parseFloat(this.unsynced_orders_amount);
                        }

                        resolve(data);
                    })
                    .catch((err) => {
                        console.log(err);
                        reject(err);
                    });
            });
        },
        getUnsyncedOrdersAmount() {
            return new Promise((resolve, reject) => {
                ApiService.get("/unsynced-orders-amount")
                    .then(({ data }) => {
                        if (!data.success) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }

                        this.unsynced_orders_amount = data.total_amount;
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getOrdersCount() {
            return new Promise((resolve, reject) => {
                ApiService.get("/orders-count")
                    .then(({ data }) => {
                        if (!data.success) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }

                        this.total_orders = data.total_orders;
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        }
    }
};
</script>
